"use strict";

exports.__esModule = true;
exports.PlantStateActivitiesRoutes = PlantStateActivitiesRoutes;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _System = require("../../../System");
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _PlantStateActivitiesScreen = require("../PlantStateActivitiesScreen");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Plant State Activities Routes
 */
function PlantStateActivitiesRoutes() {
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("PlantStateActivities") + "/*",
    element: /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.CompatRoute, {
      component: _PlantStateActivitiesScreen.PlantStateActivitiesScreen
    })
  }));
}